import { render, staticRenderFns } from "./leadReallocation.vue?vue&type=template&id=936aef7e"
import script from "./leadReallocation.vue?vue&type=script&lang=js"
export * from "./leadReallocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports